module.exports = __webpack_public_path__ + "img/plano-gold-pro.34377b26.png";